 <template>
    <gj-modal size="full-middle" class="send-rule-preview-other" v-bind="$attrs" v-on="$listeners" :loading="loading"
        :visible.sync="modalVisible">
        <template #header>预览</template>
        <template #content>
            <el-row v-if="isShow" class="content">
                <el-col :span="4">
                    <div class="content-left">
                        <span>
                            <div class="content-left-cell color333 weight600">
                                匹配订单
                            </div>
                        </span>
                        <span v-for="(item, index) in tableData" :key="index">
                            <div :key="cureentDate" @click="activeChange(index)" class="content-left-cell"
                                :class="{ 'active': item.active }">
                                {{ item.orderId }}
                            </div>
                        </span>
                    </div>
                </el-col>
                <el-col :span="20">
                    <div class="content-right">
                        <div class="content-right-header">
                            <el-row>
                                <el-col :span="8">
                                    <span>订单类型：{{ form.orderType | defaultShow }}</span>
                                    <span></span>
                                </el-col>
                                <el-col :span="8">
                                    <span>店铺/站点：</span>
                                    <span>{{ form.marketId | optionText(marketOption) }}</span>
                                </el-col>
                                <el-col :span="8">
                                    <span>状态：</span>
                                    <span>{{ form.statusName | defaultShow }}</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <span>订购时间（站点时间）：</span>
                                    <span>{{ form.purchaseDate | defaultShow }}</span>
                                </el-col>
                                <el-col :span="8">
                                    <span>发货时间（站点时间）：</span>
                                    <span>{{ form.deliveryDate | defaultShow }}</span>
                                </el-col>
                                <el-col :span="8">
                                    <span>到货时间（站点时间）：</span>
                                    <span>{{ form.expectedDeliveryTime | defaultShow }}</span>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="content-right-contet">
                            <div style="margin-bottom: 15px;">
                                邮件主题：
                                <span> {{ form.subject }}</span>
                            </div>
                            <div>
                                邮件内容：
                                <span v-html="form.content"></span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div v-else class="content" style="text-align: center; position: relative;">
                <div style="height: 80px;position: absolute;top: 50%;transform: translate(0,-50%);width: 100%;">
                    <div style="text-align: center;">
                        <div style="color:#666666;font-weight: bold;font-size:16px;margin:0 0 15px 15px;">暂无符合设置条件的订单！
                        </div>
                        <div>
                            <span> 手动输入订单 </span>
                            <gj-input v-model="order" style="width: 200px;margin:0 15px;"></gj-input>
                            <gj-button @click="queryOrderInfo">确定</gj-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </gj-modal>
</template>

<script>
import { modalMixIn } from "@/minxins";
import { mailPreview, listOrderListView } from "@/api/crm";
import { saleOrderType, saleOrderStatus } from '@/utils/options';
import { isMeaningful, isMeaningless } from "@/utils/common";
import { mapGetters } from 'vuex';
export default {
    name: "send-rule-preview-other",
    mixins: [modalMixIn],
    props: {
        dataList: Array,
        formDate: Object
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption',
      }),
    },
    data() {
        return {
            loading: false,
            tableData: this.dataList,
            isShow: this.dataList.length > 0 ? true : false,
            order: "",
            cureentDate: +new Date(),
            form: {},
            saleOrderType,
            saleOrderStatus
        }
    },
    created() {
        if(this.tableData.length > 0) {
            this.activeChange(0)
        }
    },
    methods: {
        queryOrderInfo() {
            if(this.order==='') {
                this.$gjMessage.warning("请输入订单编号！");
                return
            }
            this.loading = true
            this.formDate.orderId = this.order
            listOrderListView(this.formDate).then(res => {
                if(isMeaningful(res) && res.length > 0) {
                    this.tableData = res;
                    this.activeChange(0)
                    this.isShow = true;
                    this.cureentDate = +new Date();
                } else {
                    this.$gjMessage.error(`${this.order}订单不符合设置条件！`);
                }
            }).complete(() => this.loading = false);
        },
        activeChange(index) {
            this.tableData.forEach((res, j) => {
                res.active = false;
                if (index == j) {
                    res.active = true;
                    this.cureentDate = +new Date();
                }
            });
            this.queryMail(this.tableData[index])
        },
        queryMail(row) {
            const params = {
                countryList: this.formDate.countryList,
                mailType: this.formDate.mailType,
                marketIdList: [row.marketId],
                orderId: row.orderId,
                templateInfo: this.formDate.templateInfo
            }
            mailPreview(params).then(res => {
                this.form = Object.assign(res, row);
                this.saleOrderType.forEach(item => {
                    if (res.orderType == item.id) {
                        res.orderTypeName = item.text;
                    }
                });
                this.saleOrderStatus.forEach(item => {
                    if (res.status == item.id) {
                        res.statusName = item.text;
                    }
                })

            })
        }
    },
}
</script>

<style lang="scss">
.send-rule-preview-other {
    div.el-dialog {
        width: 1100px !important;
        height: 524px !important;

        .content {
            width: 100%;
            height: 442px;
            border: 1px solid #D8DADD;

            .el-col {
                height: 100%;

                .content-left {
                    border-right: 1px solid #D8DADD;
                    height: 100%;
                    overflow: auto;

                    .content-left-cell {
                        height: 40px;
                        line-height: 40px;
                        border-bottom: 1px solid #E4E5E6;
                        padding-left: 14px;
                        box-sizing: border-box;
                        cursor: pointer;

                        &.active {
                            background: #EEF3FB;
                            color: #1F6EEF;
                        }
                    }
                }

                .content-right {
                    height: 100%;
                    width: 100%;
                    background: #F6F8FB;
                    padding: 15px 20px;
                    box-sizing: border-box;

                    .content-right-header {
                        border-bottom: 1px solid #E4E5E6;

                        .el-row {
                            margin-bottom: 10px;
                        }

                        margin-bottom: 10px;
                    }

                    .content-right-contet {
                        height: 83%;
                        overflow: auto;

                        .content-right-contet-cell {}
                    }
                }

            }
        }
    }
}
</style>
